<template>
    <div>
        <form @submit.prevent="doSearch" class="flex flex-row gap-2">
            <input type="text" name="name" id="name"
                v-model="name"
                placeholder="Search files by name"
                required
                class="appearance-none shadow-sm rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-uknar-primary focus:border-uknar-primary focus:z-10 sm:text-sm">
            <button type="submit" class="cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-uknar-primary text-base font-medium text-white hover:bg-uknar-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-uknar-primary sm:w-auto sm:text-sm">
                Search
            </button>   
            <button type="button" @click="cancelSearch" class="cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-uknar-primary text-base font-medium text-white hover:bg-uknar-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-uknar-primary sm:w-auto sm:text-sm">
                Cancel
            </button>   
        </form>
    </div>
</template>

<script>
import { useDocumentsStore } from '../../stores/documentsStore';
import { mapStores } from 'pinia';

export default {
    data() {
        return {
            name: ''
        }
    },
    computed: {
        ...mapStores(useDocumentsStore)
    },
    methods: {
        doSearch(){
            this.documentsStore.searchDocuments(this.name);
        },
        cancelSearch(){
            if(!this.documentsStore.isSearch) return;
            this.name = '';
            this.documentsStore.cancelSearch();
        }
    },
}
</script>